// extracted by mini-css-extract-plugin
export default {"container":"y4CYve","seatDetails":"cGGftm"};